/* ARIELLE v55 – hide irrelevant weight columns only inside size charts. */
(function(){
 function cleanWeightColumns(){
   document.querySelectorAll('#Ar37SizePanel table').forEach(function(table){
     var rows=Array.from(table.querySelectorAll('tr'));
     if(!rows.length)return;
     var header=rows.find(function(row){return row.querySelector('th')&&/gewicht|weight/i.test(row.textContent||'')});
     if(!header)return;
     var cells=Array.from(header.children);
     var indexes=cells.map(function(cell,i){return /gewicht|weight/i.test(cell.textContent||'')?i:-1}).filter(function(i){return i>=0});
     if(!indexes.length)return;
     rows.forEach(function(row){
       var own=Array.from(row.children);
       indexes.slice().reverse().forEach(function(i){if(own[i])own[i].remove()});
     });
   });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',cleanWeightColumns);
 else cleanWeightColumns();
})();